import React, { useState, useEffect } from "react";
import GUI_Header from "./gui/GUI_Header";
import GUI_Credit from "./gui/GUI_Credit";
import GUI_Input3TextAreas from "./gui/GUI_Input3TextAreas";
import GUI_Select from "./gui/GUI_Select";


const Segment = () => {
	useEffect(() => {
		document.title = "Segment Operation";
	}, []);
	const [guiTxtArea, guiTxtAreaChange] = useState("1,5\n10,15\n20,25\n30,35\n40,45\n50,55\n60,65\n70,75\n80,85\n90,95\n100,105");
	const [guiTxtArea2, guiTxtArea2Change] = useState("3,8\n12,18\n22,28\n32,38\n42,48\n52,58\n62,68\n72,78\n82,88\n92,98\n112,118");
	const [guiTxtArea3, guiTxtArea3Change] = useState("");

	//--------------------
	const [selectedOption, setSelectedOption] = useState({
		value: "1",
		label: "Merge",
	});
	const selecter_option = [
		{ value: "1", label: "Merge" },
		{ value: "2", label: "Subtract (partial)" },
		{ value: "3", label: "Subtract (whole segment)" },
		{ value: "4", label: "Add (non-overlapped)" },
		{ value: "0", label: "Calculate Overlapping Percentage" },
	];
	function selection_handle(e) {
		// console.log("xxx" + e.value);
		setSelectedOption(e);
	}
	//--------------------
	const [partResult, partResultChange] = useState(<div></div>); //bottom part that show result

	const buttonClick1 = () => {
		process();
	};



	function process() {
		let typeoftest = selectedOption.value;
        var list1 = parseSegment(guiTxtArea);
        var list2 = parseSegment(guiTxtArea2);

		if (typeoftest == "1") {
            var output = joinSegments(list1, list2);
            var s = stringifySegments(output);
            guiTxtArea3Change(s);
        }
		else if (typeoftest == "2") {
            var output = subtractSegmentsWithOverlap(list1, list2);
            var s = stringifySegments(output);
            guiTxtArea3Change(s);
        }
		else if (typeoftest == "3") {
            var output = subtractSegments(list1, list2);
            var s = stringifySegments(output);
            guiTxtArea3Change(s);
        }
		else if (typeoftest == "4") {
            var output = addNonOverlappingSegments(list1, list2);
            var s = stringifySegments(output);
            guiTxtArea3Change(s);
        }
        else{
            var s = calculateOverlapPercentage(list1, list2);
            guiTxtArea3Change(s.toFixed(4));
        }
	}

    //---------------------------------------------------------------
    function parseSegment(segmentString) {
        return segmentString.split('\n').map(segment => {
          const [start, end] = segment.split(',').map(Number);
          return [start, end];
        });
      }

      function stringifySegments(segmentList) {
        return segmentList.map(segment => segment.join(',')).join('\n');
      }

    function joinSegments(list1, list2) {
        const mergedList = [...list1, ...list2];
      
        mergedList.sort((a, b) => a[0] - b[0]);
      
        const result = [mergedList[0]];
      
        for (let i = 1; i < mergedList.length; i++) {
          const currentSegment = mergedList[i];
          const lastSegment = result[result.length - 1];
      
          if (currentSegment[0] <= lastSegment[1]) {
            lastSegment[1] = Math.max(lastSegment[1], currentSegment[1]);
          } else {
            result.push(currentSegment);
          }
        }
      
        return result;
      }

      function subtractSegments(list1, list2) {
        const result = [];
      
        for (const segment1 of list1) {
          let isOverlapping = false;
      
          for (const segment2 of list2) {
            if (
              (segment1[0] >= segment2[0] && segment1[0] <= segment2[1]) ||
              (segment1[1] >= segment2[0] && segment1[1] <= segment2[1])
            ) {
              isOverlapping = true;
              break;
            }
          }
      
          if (!isOverlapping) {
            result.push(segment1);
          }
        }
      
        return result;
      }

      function subtractSegmentsWithOverlap(list1, list2) {
        const result = [];
      
        for (const segment1 of list1) {
          let remainingSegment = [segment1[0], segment1[1]];
      
          for (const segment2 of list2) {
            if (segment1[0] >= segment2[0] && segment1[1] <= segment2[1]) {
              remainingSegment = []; // The entire segment1 is within segment2, no remaining part
              break;
            } else if (segment1[0] <= segment2[0] && segment1[1] >= segment2[1]) {
              // segment1 contains segment2, subtract the overlapping part
              if (segment2[0] > remainingSegment[0]) {
                result.push([remainingSegment[0], segment2[0]]);
              }
              remainingSegment[0] = segment2[1];
            } else if (segment1[0] <= segment2[1] && segment1[1] >= segment2[0]) {
              // segment1 partially overlaps segment2, subtract the overlapping part
              remainingSegment[1] = Math.min(remainingSegment[1], segment2[0]);
            }
          }
      
          if (remainingSegment.length > 0) {
            result.push(remainingSegment);
          }
        }
      
        return result;
      }
      
      

      function calculateOverlapPercentage(list1, list2) {
        let totalOverlapLength = 0;
      
        for (const segment1 of list1) {
          for (const segment2 of list2) {
            const overlapStart = Math.max(segment1[0], segment2[0]);
            const overlapEnd = Math.min(segment1[1], segment2[1]);
            
            if (overlapEnd >= overlapStart) {
              totalOverlapLength += overlapEnd - overlapStart;
            }
          }
        }
      
        const totalSegmentLength = calculateTotalLength(list1) + calculateTotalLength(list2);
        const overlapPercentage = (totalOverlapLength / totalSegmentLength) * 100;
      
        return overlapPercentage;
      }
      
      function calculateTotalLength(segments) {
        let totalLength = 0;
        for (const segment of segments) {
          totalLength += segment[1] - segment[0];
        }
        return totalLength;
      }


      function addNonOverlappingSegments(list1, list2) {
        const result = [...list1];
      
        for (const segment2 of list2) {
          let isOverlapping = false;
      
          for (const segment1 of list1) {
            if (
              (segment2[0] >= segment1[0] && segment2[0] <= segment1[1]) ||
              (segment2[1] >= segment1[0] && segment2[1] <= segment1[1])
            ) {
              isOverlapping = true;
              break;
            }
          }
      
          if (!isOverlapping) {
            result.push(segment2);
          }
        }
      
        return result;
      }
    //---------------------------------------------------------------

	return (
		<div className="todoapp stack-large">
			<GUI_Header
				title={"Segment Operation"}
				desc={
					""
				}
			/>
			<GUI_Input3TextAreas
				id="inputItemList"
				className="textarea_001"
				placeholder={"name,size,value"}
				area1Change={guiTxtAreaChange}
				text1={guiTxtArea}
				area2Change={guiTxtArea2Change}
				text2={guiTxtArea2}
				area3Change={guiTxtArea3Change}
				text3={guiTxtArea3}
				label={"Input 1"}
				label2={"Input 2"}
				label3={"Output"}
			/>
            <GUI_Select
				label={"Operation"}
				width1={250}
				selecter_option={selecter_option}
				selectedOption={selectedOption}
				setSelectedOption={selection_handle}
			/>
			<div style={{ display: "flex", marginLeft: "3%", marginRight: "3%" }}>
				<button
					onClick={() => buttonClick1()}
					className="btn btn__primary btn__lg"
					style={{ flex: 1, height: 50 }}
				>
					Calculate
				</button>
			</div>
			{partResult}
			<GUI_Credit />
		</div>
	);
};

export default Segment;
